import Card from '@material-ui/core/Card';
import Divider from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/core/styles';
import InstallerIcon from '@material-ui/icons/Build';
import ManagerIcon from '@material-ui/icons/Computer';
import RightArrowIcon from '@material-ui/icons/KeyboardArrowRight';
import SmartPhoneIcon from '@material-ui/icons/Smartphone';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { isMobileBrowser } from '../../_config/utils';

const styles = theme => ({
  root: {
    flexGrow: 1,
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    padding: '20px 20px',
    backgroundColor: '#157495',
    backgroundImage: 'url(/imgs/common/loginBackground.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(to right, rgba(21, 116, 149, 0.7), rgba(21, 116, 149, 0.7))',
      zIndex: 0,
    },
  },
  centerPanel: {
    width: '100%',
    maxWidth: '550px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    zIndex: 1,
  },
  logo: {
    height: '80px',
    marginBottom: '20px',
  },
  contentCard: {
    width: '100%',
    padding: '40px',
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
  },
  '@keyframes scaleIn': {
    '0%': {
      transform: 'scale(0)',
      opacity: 0,
    },
    '50%': {
      transform: 'scale(1.1)',
    },
    '100%': {
      transform: 'scale(1)',
      opacity: 1,
    }
  },
  '@keyframes pulse': {
    '0%': {
      boxShadow: '0 0 0 0 rgba(77, 182, 172, 0.7)',
    },
    '70%': {
      boxShadow: '0 0 0 20px rgba(77, 182, 172, 0)',
    },
    '100%': {
      boxShadow: '0 0 0 0 rgba(77, 182, 172, 0)',
    }
  },
  successIcon: {
    alignSelf: 'center',
    marginBottom: '0px',
    color: '#4DB6AC',
    fontSize: '64px',
    animation: '$scaleIn 0.5s ease-out',
  },
  successIconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '80px',
    height: '80px',
    margin: '0 auto 20px',
    borderRadius: '50%',
    backgroundColor: 'rgba(77, 182, 172, 0.1)',
    animation: '$pulse 2s infinite',
  },
  successTitle: {
    fontSize: '28px',
    fontWeight: '600',
    color: '#333',
    textAlign: 'center',
    marginTop: 0,
    marginBottom: '32px',
  },
  optionCard: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '10px',
    cursor: 'pointer',
    padding: '16px 20px',
    marginBottom: '12px',
    transition: 'all 0.2s ease',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
    '&:hover': {
      boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.12)',
      transform: 'translateY(-2px)',
    }
  },
  primaryCard: {
    backgroundColor: '#4DB6AC',
    '&:hover': {
      backgroundColor: '#45a89e',
    }
  },
  divider: {
    height: '1px',
    backgroundColor: '#e0e0e0',
    margin: '24px 0',
  }
});

@connect((state) => ({ routing: state.router }))
class ResetPassowordLanding extends React.Component {
  render() {
    const { dispatch, classes } = this.props;
    const isMobile = isMobileBrowser();

    if (isMobile) {
      return (
        <div style={{
          minHeight: '100vh',
          width: '100%',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
          WebkitOverflowScrolling: 'touch',
          backgroundColor: '#157495',
        }}>
          <div style={{
            minHeight: '100%',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundImage: 'url(/imgs/common/loginBackground.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed',
            padding: '40px 20px',
            position: 'relative',
          }}>
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              minHeight: '100%',
              background: 'linear-gradient(135deg, rgba(21, 116, 149, 0.92), rgba(18, 99, 127, 0.95))',
              zIndex: 0,
              pointerEvents: 'none',
            }} />
            <div style={{
              position: 'relative',
              zIndex: 2,
              width: '100%',
              maxWidth: '400px',
              paddingTop: '20px',
              paddingBottom: '40px',
            }}>
              <img 
                src="/imgs/common/logoJagoWhite.png" 
                alt="Luckey" 
                style={{
                  height: '50px',
                  marginBottom: '20px',
                  display: 'block',
                  margin: '0 auto 20px',
                }}
              />
              <div className={classes.successIconWrapper}>
                <VerifiedUserIcon className={classes.successIcon} style={{ fontSize: 40 }} />
              </div>
              <h1 style={{
                fontSize: '22px',
                fontWeight: '600',
                color: 'white',
                textAlign: 'center',
                marginBottom: '32px',
                marginTop: 0,
                textShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
              }}>
                <Entity entity="passwordRecoverSuccess" />
              </h1>
              
              <Card
                style={{ 
                  backgroundColor: '#4DB6AC', 
                  display: 'flex', 
                  flexDirection: 'row', 
                  alignItems: 'center', 
                  justifyContent: 'space-between', 
                  borderRadius: 10, 
                  cursor: 'pointer', 
                  padding: '16px 20px', 
                  marginBottom: 12,
                  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
                }}
                onClick={() => dispatch(push('/resetPassOnboardingGuest'))}
              >
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <SmartPhoneIcon style={{ fontSize: 24, color: 'white', marginRight: 12 }} />
                  <h5 style={{ fontSize: 14, fontWeight: '500', margin: 0, color: 'white' }}>
                    <Entity entity="continueAsGuestInstruction" />
                  </h5>
                </div>
                <RightArrowIcon style={{ color: 'white', fontSize: 28 }} />
              </Card>
              
              <Divider style={{ height: 1, marginTop: 24, marginBottom: 24, backgroundColor: 'rgba(255, 255, 255, 0.2)' }} />
              
              <Card 
                style={{ 
                  backgroundColor: 'white',
                  display: 'flex', 
                  flexDirection: 'row', 
                  alignItems: 'center', 
                  justifyContent: 'space-between', 
                  borderRadius: 10, 
                  cursor: 'pointer', 
                  padding: '16px 20px', 
                  marginBottom: 12,
                  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
                }} 
                onClick={() => dispatch(push('/login'))}
              >
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <ManagerIcon style={{ fontSize: 24, color: '#157495', marginRight: 12 }} />
                  <div>
                    <h4 style={{ fontWeight: '600', fontSize: 13, margin: 0, marginBottom: 4, color: '#333' }}>
                      <Entity entity="areYouAManager" />
                    </h4>
                    <h5 style={{ fontSize: 12, margin: 0, color: '#666' }}>
                      <Entity entity="goToWebPlatform" />
                    </h5>
                  </div>
                </div>
                <RightArrowIcon style={{ color: '#157495', fontSize: 28 }} />
              </Card>
              
              <Card 
                style={{ 
                  backgroundColor: 'white',
                  display: 'flex', 
                  flexDirection: 'row', 
                  alignItems: 'center', 
                  justifyContent: 'space-between', 
                  cursor: 'pointer', 
                  borderRadius: 10, 
                  padding: '16px 20px',
                  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
                }} 
                onClick={() => dispatch(push('/resetPassOnboardingInstaller'))}
              >
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <InstallerIcon style={{ fontSize: 24, color: '#157495', marginRight: 12 }} />
                  <h5 style={{ fontSize: 13, fontWeight: '500', margin: 0, color: '#333' }}>
                    <Entity entity="continueAsInstaller" />
                  </h5>
                </div>
                <RightArrowIcon style={{ color: '#157495', fontSize: 28 }} />
              </Card>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className={classes.root}>
        <div className={classes.centerPanel}>
          <img 
            src="/imgs/common/logoJagoWhite.png" 
            alt="Luckey"
            className={classes.logo}
          />
          
          <div className={classes.contentCard}>
            <div className={classes.successIconWrapper}>
              <VerifiedUserIcon className={classes.successIcon} />
            </div>
            <h2 className={classes.successTitle}>
              <Entity entity="passwordRecoverSuccess" />
            </h2>
            
            <Card
              className={`${classes.optionCard} ${classes.primaryCard}`}
              onClick={() => dispatch(push('/resetPassOnboardingGuest'))}
              style={{ backgroundColor: '#4DB6AC', color: 'white' }}
            >
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <SmartPhoneIcon style={{ fontSize: 28, color: 'white', marginRight: 16 }} />
                <h5 style={{ fontSize: 15, fontWeight: '500', margin: 0, color: 'white' }}>
                  <Entity entity="continueAsGuestInstruction" />
                </h5>
              </div>
              <RightArrowIcon style={{ color: 'white', fontSize: 32 }} />
            </Card>
            
            <div className={classes.divider} />
            
            <Card 
              className={classes.optionCard}
              onClick={() => dispatch(push('/login'))}
            >
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <ManagerIcon style={{ fontSize: 28, color: '#157495', marginRight: 16 }} />
                <div>
                  <h4 style={{ fontWeight: '600', fontSize: 15, margin: 0, marginBottom: 4, color: '#333' }}>
                    <Entity entity="areYouAManager" />
                  </h4>
                  <h5 style={{ fontSize: 13, margin: 0, color: '#666', fontWeight: '400' }}>
                    <Entity entity="goToWebPlatform" />
                  </h5>
                </div>
              </div>
              <RightArrowIcon style={{ color: '#157495', fontSize: 32 }} />
            </Card>
            
            <Card 
              className={classes.optionCard}
              onClick={() => dispatch(push('/resetPassOnboardingInstaller'))}
            >
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <InstallerIcon style={{ fontSize: 28, color: '#157495', marginRight: 16 }} />
                <h5 style={{ fontSize: 15, fontWeight: '500', margin: 0, color: '#333' }}>
                  <Entity entity="continueAsInstaller" />
                </h5>
              </div>
              <RightArrowIcon style={{ color: '#157495', fontSize: 32 }} />
            </Card>
          </div>
        </div>
      </div>
    );
  }
} 

export default withStyles(styles)(ResetPassowordLanding);
